
import { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import iconSet from "selection.json";
import IcomoonReact, { iconList } from "icomoon-react";
import decodeJwt from 'jwt-decode';

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

var ps;

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (!prop.show) {
        return null;
      }
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
            style={{ color: '#334B57' }}
            className="inactive" activeClassName="active"
            activeStyle={{ color: '#2FBBC1', backgroundColor: '#cce0ff', marginLeft: 10, marginRight: 40, borderRadius: 30, padding: 10, position: 0 }}
            inactiveStyle={{ color: '#fff', textDecoration: 'none' }}
          >
            <IcomoonReact iconSet={iconSet} activeClassName="active" activeStyle={{ Color: 'red', size: 10 }} color="#334B57" size={16} icon={prop.icon} style={{ marginRight: 15 }} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };
  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }
  let token = localStorage.getItem('token');
  const decodedToken = decodeJwt(token);
  const name = decodedToken.user.fullname;
  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
              style={{ maxHeight: '8rem' }}
            />
          </NavbarBrand>
        ) : null}


        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          <hr className="my-3" />
          {/* Navigation */}
          <Nav navbar>{createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className="my-3" />
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            <div><label style={{ fontWeight: 'bold', color: 'black', textTransform: 'capitalize', marginRight: 25 }}>{name}</label></div>
            <div style={{ marginLeft: 15 }}><Link to='/settings'><IcomoonReact style={{ fontWeight: 'bold' }} iconSet={iconSet} color="#208afc" size={16} icon="right-chevron" /></Link></div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ marginLeft: 15 }}><Link to='/settings'><IcomoonReact iconSet={iconSet} color="#2d91fc" size={16} icon="user-settings" /></Link></div>
            <div style={{ marginLeft: 4 }}><Link to='/settings' style={{ color: '#adc2de', fontSize: '0.8rem' }}>Settings</Link></div>
          </div>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
